export const GET_WALLETS = "GET_WALLETS";
export const GET_WALLET_STATS = "GET_WALLET_STATS";
export const GET_REWARD_TRANSACTIONS = "GET_REWARD_TRANSACTIONS";
export const GET_EARNING_RULES = "GET_EARNING_RULES";
export const UPDATE_WALLET_STATUS = "UPDATE_WALLET_STATUS";
export const WALLET_ADJUSTED = "WALLET_ADJUSTED";
export const UPDATE_EARNING_RULE = "UPDATE_EARNING_RULE";
